import React from "react";
import "./SimpleHeader.css";

interface SimpleHeaderProps {
  onHome?: () => void;
  onResources?: () => void;
}

export default function SimpleHeader({ onHome, onResources }: SimpleHeaderProps) {
  const handleHome = () => {
    if (onHome) {
      onHome();
    } else {
      window.location.href = '/';
    }
  };

  const handleResources = () => {
    if (onResources) {
      onResources();
    } else {
      window.location.href = '/resources';
    }
  };

  return (
    <header className="simple-header">
      <nav className="simple-header-nav">
        <button className="simple-header-link" onClick={handleHome}>
          Գլխավոր
        </button>
        <button className="simple-header-link" onClick={handleResources}>
          Ռեսուրսներ
        </button>
      </nav>
    </header>
  );
}
